// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1748":"f3eb925d","2015":"62030658","3006":"f3eb925d","3767":"f3eb925d","5152":"b69c9285","5520":"a60ccc05","6855":"f3eb925d","8169":"a60ccc05","8579":"f3eb925d"}[chunkId] + ".chunk.css";
};